import React, { memo, useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  setActiveLocation,
  updatePolygon,
  updateSegmentEndpoints
} from '@actions/data-detail-actions';

import MapEdit from '@components/entity/info/map-edit';
import FloatingBar from '@components/map/floating-bar';
import LayersMenu from '@components/map/layers-menu';

import { convertFromGoogleMapsShape } from '@utils/map-tools-utils';

import './map.scss';

const Map = () => {
  const dispatch = useDispatch();
  const {
    data,
    activeLocation: {
      activeSegmentId,
      activeStart,
      activeEnd
    }
  } = useSelector(state => state.dataDetail);
  const segments = data?.segments;

  const activeSegment = useMemo(
    () => segments?.find(seg => seg.id === activeSegmentId),
    [segments, activeSegmentId]
  );

  const onActiveSegmentChanged = useCallback(
    endPoints => {
      const newEndPoints = { ...{ start: activeStart, end: activeEnd }, ...endPoints };
      dispatch(setActiveLocation({
        activeStart: newEndPoints.start,
        activeEnd: newEndPoints.end
      }));
      dispatch(updateSegmentEndpoints(newEndPoints, activeSegmentId, activeSegment.override_street_centering, 'map'));
    },
    [activeEnd, activeSegment, activeSegmentId, activeStart, dispatch]
  );

  const onActivePolygonChanged = useCallback(
    mapsShape => {
      dispatch(setActiveLocation({
        activeStart: null,
        activeEnd: null
      }));
      const shape = convertFromGoogleMapsShape(mapsShape);
      dispatch(updatePolygon(activeSegmentId, shape, 'map'));
    },
    [activeSegmentId, dispatch]
  );

  return (
    <div styleName="map-container">
      <FloatingBar legend={false} tools={false} />
      <LayersMenu style={{ right: '1rem' }} />
      <MapEdit
        segments={segments}
        onActiveSegmentChanged={onActiveSegmentChanged}
        onPolygonChanged={onActivePolygonChanged}
      />
    </div>
  );
};

export default memo(Map);
